export namespace ErrorType {
  export const LoginError = "login_error";
}
